import { executeStandardRequest, type MusinsaStandardResponse } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import { z } from 'zod';
import { publicHttpClient } from '../httpClient';
import { joinApiPath } from './apiPath';

export const CheckSnsDuplicateRequestParamsSchema = z
  .object({
    urls: z.array(z.string()).min(1).max(2),
  })
  .describe('CheckSnsDuplicateRequestParamsSchema');

export type CheckSnsDuplicateRequestParams = z.infer<typeof CheckSnsDuplicateRequestParamsSchema>;

const CheckSnsDuplicateResponseDataSchema = z
  .object({
    isDuplicated: z.boolean(),
    duplicatedUrls: z.array(z.string()),
  })
  .describe('CheckSnsDuplicateResponseDataSchema');

export type CheckSnsDuplicateResponse = MusinsaStandardResponse<
  z.infer<typeof CheckSnsDuplicateResponseDataSchema>
>;

export const checkSnsDuplicate = (params: CheckSnsDuplicateRequestParams) => {
  // URLs를 쿼리 파라미터로 변환: urls=value1&urls=value2
  const queryParams = new URLSearchParams();
  params.urls.forEach((url) => queryParams.append('urls', url));

  return executeStandardRequest(() =>
    publicHttpClient.get<CheckSnsDuplicateResponse>(
      `${urlJoin(joinApiPath.checkSnsDuplicate)}?${queryParams.toString()}`,
    ),
  );
};
